function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState as m, useRef as E, useEffect as S } from "react";
import { MASK as g, PLACEHOLDER as b, DEFAULT_PLACEHOLDER as F, DATES_SEPARATOR as R } from "./index.es538.js";
import { datesToValue as A, valueToDates as M, autoFillSeparators as D, validateValue as O } from "./index.es539.js";
import { generateRegExp as x } from "./index.es540.js";
var L = g.map(x),
  T = function T(n) {
    return L.slice(0, n.length).every(function (l, i) {
      return l.test(n[i]);
    });
  },
  B = function B(_ref) {
    var _s$current$selectionS, _s$current, _s$current$selectionE, _s$current2;
    var n = _ref.value,
      l = _ref.onFinishChange,
      i = _ref.placeholder;
    var _m = m(!1),
      _m2 = _slicedToArray(_m, 2),
      d = _m2[0],
      p = _m2[1],
      _m3 = m(n ? A(n) : ""),
      _m4 = _slicedToArray(_m3, 2),
      e = _m4[0],
      r = _m4[1],
      s = E(null),
      c = E({
        start: (_s$current$selectionS = (_s$current = s.current) === null || _s$current === void 0 ? void 0 : _s$current.selectionStart) !== null && _s$current$selectionS !== void 0 ? _s$current$selectionS : null,
        end: (_s$current$selectionE = (_s$current2 = s.current) === null || _s$current2 === void 0 ? void 0 : _s$current2.selectionEnd) !== null && _s$current$selectionE !== void 0 ? _s$current$selectionE : null
      }),
      a = function a() {
        l !== null && l !== void 0 && l(null), r("");
      },
      P = function P() {
        p(!1), e.length !== g.length && a();
      },
      C = function C() {
        setTimeout(function () {
          var _s$current3;
          (_s$current3 = s.current) === null || _s$current3 === void 0 || _s$current3.setSelectionRange(c.current.start, c.current.end);
        });
      },
      _h = function h(t) {
        var _s$current$selectionS2, _s$current4, _s$current$selectionE2, _s$current5, _s$current$selectionS3, _s$current6, _s$current$selectionS4, _s$current7;
        var _ = t.length < e.length;
        c.current.start = (_s$current$selectionS2 = (_s$current4 = s.current) === null || _s$current4 === void 0 ? void 0 : _s$current4.selectionStart) !== null && _s$current$selectionS2 !== void 0 ? _s$current$selectionS2 : null, c.current.end = (_s$current$selectionE2 = (_s$current5 = s.current) === null || _s$current5 === void 0 ? void 0 : _s$current5.selectionEnd) !== null && _s$current$selectionE2 !== void 0 ? _s$current$selectionE2 : null;
        var o = e.split("").map(function (u, f) {
          return [u, f];
        }).find(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            u = _ref3[0],
            f = _ref3[1];
          return u !== t[f];
        });
        _ ? function (_o$) {
          /\d/.test((_o$ = o === null || o === void 0 ? void 0 : o[0]) !== null && _o$ !== void 0 ? _o$ : "") ? r(t) : o && o[1] !== t.length && !/\d/.test(o[0]) || (C(), r(e.slice(e.length - 3, e.length) === R ? t.replace(R.slice(0, -1), "").slice(0, -1) : t.slice(0, t.length - 1)));
        }() : T(t) && t.length <= L.length ? r(D(O(D(t)))) : T("".concat(t.slice(0, (_s$current$selectionS3 = (_s$current6 = s.current) === null || _s$current6 === void 0 ? void 0 : _s$current6.selectionStart) !== null && _s$current$selectionS3 !== void 0 ? _s$current$selectionS3 : 0), "0").concat(t.slice((_s$current$selectionS4 = (_s$current7 = s.current) === null || _s$current7 === void 0 ? void 0 : _s$current7.selectionStart) !== null && _s$current$selectionS4 !== void 0 ? _s$current$selectionS4 : 0))) ? r(t.slice(0, 31)) : _h(t.slice(0, -1));
      };
    return S(function () {
      r(n ? A(n) : "");
    }, [n]), S(function () {
      var _s$current8;
      e.length === g.length && (l !== null && l !== void 0 && l(M(e)), (_s$current8 = s.current) === null || _s$current8 === void 0 ? void 0 : _s$current8.blur());
    }, [e]), {
      time: e,
      cleanValue: a,
      isFocused: d,
      setIsFocused: p,
      onBlur: P,
      inputPlaceholder: d ? b.substring(e.length) : i || F,
      onChangeInput: _h,
      inputRef: s
    };
  };
export { B as useConfig };